<script setup>
import Swal from "sweetalert2";
import {computed, watch} from "vue";
import {useForm} from "@inertiajs/vue3";
import Modal from "@/components/Shared/Modal.vue";
import FormButton from "@/components/Shared/Form/Button.vue";
import FormInput from "@/components/Shared/Form/Input/Index.vue";
import axios from "axios";

const emit = defineEmits(["close"]);

const props = defineProps({
  show: Boolean,
  userIntegrationId: [String, Number],
  userIntegrationFlowId: [String, Number],
  type: String,
  payload: {
    type: Object,
    default: {}
  }
});

const appliesToOptions = computed(() => {
  let options = {
    "business_rule": ["None"],
    "data_mapping": ["Both", "Get", "Send"],
  };

  return options[props.type] ?? ["None", "Both", "Get", "Send"];
});

const form = useForm({
  title: null,
  description: null,
  access_level: null,
  applies_to: props.applies_to,
  payload: props.payload,
});

const accessLevels = [
  {
    key: 0,
    title: "Everyone"
  },
  {
    key: 1,
    title: "Admin only"
  },
  {
    key: 2,
    title: "Private"
  }
];

const store = () => {
  form.processing = true;
  form.clearErrors();

  const data = form.data();

  data.access_level = data.access_level?.key ?? null;

  axios
    .post(`/api/integrations/${props.userIntegrationId}/flows/${props.userIntegrationFlowId}/templates/${props.type}`, data)
    .then(({data}) => {
      close();

      Swal.fire({
        text: data.message,
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
      });
    })
    .catch(error => {
      if (error.response?.status === 422) {
        form.setError(error.response.data.errors);
      } else {
        throw error;
      }
    })
    .finally(() => form.processing = false);
};

const close = () => emit("close");

watch(() => props.show, () => {
  form.clearErrors();
  form.reset();
});
</script>
<template>
  <modal :show="show" @close="close">
    <template #title>
      Store as template
    </template>
    <template #content>
      <div class="mt-4">
        <form-input
          v-model="form.title"
          :error="form.errors.title"
          label-text="Title"
          required
        />
      </div>
      <div class="mt-4">
        <form-input
          v-model="form.description"
          type="textarea"
          :error="form.errors.description"
          label-text="Description"
        />
      </div>
      <div class="mt-4">
        <form-input
          v-model="form.access_level"
          type="select"
          :options="accessLevels"
          track-by="key"
          label="title"
          :error="form.errors.access_level"
          label-text="Access Level"
          required
        />
      </div>
      <div v-if="appliesToOptions.length > 0" class="mt-4">
        <form-input
          v-model="form.applies_to"
          type="select"
          :options="appliesToOptions"
          :error="form.errors.applies_to"
          label-text="Applies to"
          required
        />
      </div>
    </template>
    <template #footer>
      <form-button class="button_cancel" :value="trans('common.cancel')" @click.prevent="close"/>

      <form-button class="ml-3"
                   :value="trans('common.add')"
                   :processing="form.processing"
                   @click.prevent="store"/>
    </template>
  </modal>
</template>
